// extracted by mini-css-extract-plugin
export var layout = "pageLayout-module--layout--bbae4";
export var title = "pageLayout-module--title--159c6";